import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_ANALYTICS_STICKY_COLUMNS,
  UPDATE_ANALYTICS_STICKY_COLUMNS, 
} from "./actionTypes"

import { 
  getAnalyticsStickyColumnsError,
  getAnalyticsStickyColumnsSuccess,
  updateAnalyticsStickyColumnsError, 
  updateAnalyticsStickyColumnsSuccess, 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetAnalyticsStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_analytics`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getAnalyticsStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getAnalyticsStickyColumnsError(error))
  }
}

function* onUpdateAnalyticsStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_analytics/${action?.payload?.user_col_pref_analytic?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAnalyticsStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateAnalyticsStickyColumnsError(error))
  }
}

function* userAnalyticsColumnPreferenceSaga() {
  yield takeEvery(GET_ANALYTICS_STICKY_COLUMNS, onGetAnalyticsStickyColumns)
  yield takeEvery(UPDATE_ANALYTICS_STICKY_COLUMNS, onUpdateAnalyticsStickyColumns)
}

export default userAnalyticsColumnPreferenceSaga;
